// ABOUTME: Main content wrapper with dynamic padding based on route
// ABOUTME: Creator pages get full-width, dashboard pages get sidebar padding

"use client"

import { usePathname } from "next/navigation"
import { useAuth } from "@clerk/nextjs"

// Check if we're on a creator's public page (/@username or /@username/*)
function isCreatorPage(pathname: string): boolean {
  return pathname.startsWith("/@") && pathname.length > 2
}

// Pages that never have any navigation padding
function isFullWidthPage(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/sign-in" ||
    pathname === "/sign-up" ||
    pathname === "/coming-soon" ||
    pathname === "/home-minimal" ||
    pathname === "/bookmarks/add" ||
    pathname === "/new" ||
    pathname === "/brand" ||
    pathname === "/privacy" ||
    pathname === "/tos" ||
    pathname === "/dmca" ||
    pathname === "/experimental-home" ||
    pathname.startsWith("/tools") ||
    (pathname.includes("/posts/") && pathname.endsWith("/edit"))
  )
}

interface MainContentProps {
  children: React.ReactNode
}

export function MainContent({ children }: MainContentProps) {
  const pathname = usePathname()
  const { isSignedIn } = useAuth()

  // Creator pages: only mobile top padding (for the minimal header), no sidebar
  if (isCreatorPage(pathname)) {
    return (
      <main className="min-h-screen pt-14 md:pt-0">
        {children}
      </main>
    )
  }

  // Full width pages: no padding at all
  if (isFullWidthPage(pathname)) {
    return (
      <main className="min-h-screen">
        {children}
      </main>
    )
  }

  // Dashboard pages: mobile top padding + desktop sidebar padding (if signed in)
  // When signed out, only mobile top padding for the TopBar
  return (
    <main className={`min-h-screen pt-14 md:pt-0 ${isSignedIn ? "md:pl-14 xl:pl-52" : ""}`}>
      {children}
    </main>
  )
}
